import React, { FC } from 'react';
import cls from 'classnames';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';

import { LegalStringColor, LegalStringProps } from './LegalString.types';
export const classNames = getClassNames('sds-legal-string', []);


const colorMap = {
	[LegalStringColor.lead]: 'text-onSurface',
	[LegalStringColor.supporting]: 'text-onSurfaceVariant',
	[LegalStringColor.inverse]: 'text-inverseOnSurface',
};

const LegalString: FC<LegalStringProps> & {
	Color: typeof LegalStringColor;
} = (props) => {
	const { footnote, className, color = LegalStringColor.supporting, children } = props;
	const thisClassNames = cls(getRootClassListFromProps(classNames,props), colorMap[color], className);

	return footnote ? (
		<li className={thisClassNames} value={footnote}>
			{children}
		</li>
	) : (
		<p className={thisClassNames}>{children}</p>
	);
};

LegalString.displayName = 'LegalString';
LegalString.Color = LegalStringColor;

export default LegalString;
